import { render, staticRenderFns } from "./account-company-monthly-quotas-widget.vue?vue&type=template&id=0c5f61e6&"
import script from "./account-company-monthly-quotas-widget.vue?vue&type=script&lang=js&"
export * from "./account-company-monthly-quotas-widget.vue?vue&type=script&lang=js&"
import style0 from "./account-company-monthly-quotas-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports